<template>
  <div>
    <div v-if="isModalOpen" class="modal fade show d-block" tabindex="-1" role="dialog" @click.self="closeModal">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ modalTitle }}</h5>
            <button type="button" class="close" @click="closeModal" aria-label="Fechar">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="d-flex justify-content-between mb-3">
              <b-button class="btn btn-sm btn-third rounded-4" size="sm" @click="showModalNewLead">
                <i class="fas fa-user-plus"></i>
                <span>&nbsp; Nova Oportunidade</span>
              </b-button>
              <button type="button" class="btn btn-third btn-sm" v-b-tooltip.hover :title="tooltipBack" @click="$emit('onBack')">
                <i class="fas fa-undo"></i>
                <span class="d-md-down-none">{{ buttonBackText }}</span>
              </button>
            </div>
            <b-tabs class="card__tab__container" card justified>
              <b-tab v-for="(tab, key) in tabs" :key="key" :title="tab.title" :active="tab.active">
                <div class="col-md-4 d-inline-block" v-for="(card, index) in tab.cards" :key="card.id">
                  <p>{{ card.boardColumn.board.nome }} -- {{ card.boardColumn.nome }}</p>
                  <task-card
                    :task="card"
                    :color="card.boardColumn.cor"
                    :boardColumnId="card.boardColumn.id"
                    :boardPosition="card.boardColumn.position || 0"
                    :percentage="card.boardColumn.percentual"
                    :hoursUntilAlert="card.boardColumn.hoursUntilAlert"
                    :index="index"
                    :hasObservation="false"
                    @Open="showLead(card)"
                  ></task-card>
                </div>
              </b-tab>
            </b-tabs>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <ModalCard
      ref="ModalCard"
      v-if="selectedCard"
      @hideModal="onModalCardClosed"
      :key="selectedCard"
      @reloadBoardColumns="() => {}"
      :boardColumns="[]"
      :cardId="selectedCard"
      :pessoaRelacionada="pessoaRelacionada"
    />

    <NewLeadModal
      ref="NewLeadModal"
      v-if="modalNewLeadOpen"
      @closeModal="closeModalNewLead"
      :pessoa="pessoa"
    />
  </div>
</template>

<script>
import TaskCard from '@/views/private/crm/components/TaskCard.vue'
import CardRepository from '@/shared/http/repositories/crm/card.js'
import NewLeadModal from '@/views/private/visitas/deslocamento/modal/newCard/newcard.vue'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'
import ManagerRepository from '@/shared/http/repositories/configurations/person.js'

export default {
  name: 'FollowUp',
  props: {
    document: {
      type: String,
      required: true
    },
    modalTitle: {
      type: String,
      default: 'Detalhes do FollowUp'
    },
    tooltipBack: {
      type: String,
      default: 'Voltar'
    },
    buttonBackText: {
      type: String,
      default: 'Voltar'
    },
    pessoaRelacionada: {
      type: Array,
      default: () => []
    }
  },
  components: {
    TaskCard,
    NewLeadModal,
    ModalCard
  },
  data () {
    return {
      isModalOpen: false,
      cards: [],
      tabs: [],
      selectedCard: null,
      modalNewLeadOpen: false,
      pessoa: null // Adicionando a propriedade para armazenar o objeto pessoa
    }
  },
  methods: {
    async openModal () {
      try {
        this.isModalOpen = true
        await this.loadCards()
      } catch (error) {
        console.error('Erro ao abrir o modal:', error)
      }
    },
    closeModal () {
      this.isModalOpen = false
      this.$emit('close')
    },
    async loadCards () {
      if (!this.document) {
        console.error('Documento não fornecido.')
        return
      }
      try {
        const response = await CardRepository.SearchAllByDocument(this.document)
        const allCards = response.data.content
        this.cards = {
          ativos: allCards.filter(c => c.situacao === 'ATIVO'),
          ganhos: allCards.filter(c => c.situacao === 'GANHO'),
          perdidos: allCards.filter(c => c.situacao === 'PERDIDO'),
          finalizados: allCards.filter(c => c.situacao === 'FINALIZADO')
        }

        this.tabs = [
          { title: 'ATIVOS', cards: this.cards.ativos, active: true },
          { title: 'GANHOS', cards: this.cards.ganhos },
          { title: 'PERDIDOS', cards: this.cards.perdidos },
          { title: 'FINALIZADOS', cards: this.cards.finalizados }
        ]
      } catch (error) {
        console.error('Erro ao carregar os cartões:', error)
      }
    },
    showLead (card) {
      this.isModalOpen = false // Fecha o FollowUp
      this.selectedCard = card.id
    },
    onModalCardClosed () {
      this.selectedCard = null
      this.isModalOpen = true // Reabre o FollowUp
    },
    async showModalNewLead () {
      try {
        if (!this.document) {
          console.error('Documento não fornecido.')
          return
        }
        const response = await ManagerRepository.GetByDocument(this.document)
        const pessoaData = response.data.content

        if (Array.isArray(pessoaData)) {
          this.pessoa = pessoaData[0] || null
        } else {
          this.pessoa = pessoaData
        }

        this.isModalOpen = false
        this.modalNewLeadOpen = true
      } catch (error) {
        console.error('Erro ao buscar o objeto pessoa:', error)
      }
    },
    closeModalNewLead () {
      this.modalNewLeadOpen = false
      this.isModalOpen = true
      this.loadCards()
    }
  }
}
</script>

<style scoped lang="scss">
.modal.fade.show {
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-body {
  max-height: 70vh;
  overflow-y: auto;
}
.modal-lg {
  max-width: 80%;
}
.card__tab__container {
  .tab-content {
    background-color: #e4e5e6;
    background: #e4e5e6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/modals/FollowUp.vue